<h2 mat-dialog-title>Add Ownerships</h2>

<div>
  <mat-dialog-content>
    <div class="dialog-content-container">
    <app-text-input label="Name" [control]="ownershipForm.controls.name"></app-text-input>

    <app-select-input label="Country" [control]="ownershipForm.controls.country" [lookupItems]="countries"
      placeholder="Select a Country">
    </app-select-input>

    <app-select-input label="Industry Type" [control]="ownershipForm.controls.industry" [lookupItems]="industries"
      placeholder="Select an Industry">
    </app-select-input>

    <app-select-input label="Your type of ownership/interest in the business?" shortLabel="Ownership/Interest"
      [control]="ownershipForm.controls.ownershipInterest" [lookupItems]="ownershipInterests"
      placeholder="Select an Ownership/Interest">
    </app-select-input>

    <app-text-input label="Your position/title in the business" shortLabel="Position"
      [control]="ownershipForm.controls.position"></app-text-input>
    <app-date-input label="Date you began involvement in this business"
      [control]="ownershipForm.controls.dateStart"></app-date-input>


    <mat-divider></mat-divider>

    <h4>
        Provide the turnover (in $AUD) and your ownership interest and net assets in this business for each of the last
        4 fiscal years.
    </h4>

    @for (year of ownershipForm.controls.years.controls; track $index; let i = $index){

    <h4>Year {{i + 1}}</h4>

    <app-date-input label="Year End Date" [control]="year.controls.yearEnd"></app-date-input>
    <app-select-input label="Turnover" [control]="year.controls.turnover" [lookupItems]="assetAmounts"
      placeholder="Select Turnover">
    </app-select-input>
    <app-text-input label="Ownership Interest (%)" [control]="year.controls.ownershipInterest" shortLabel="Ownership Interest"></app-text-input>
    <app-select-input label="Net Assets" [control]="year.controls.netAssets" [lookupItems]="assetAmounts"
      placeholder="Select Net Assets">
    </app-select-input>
    
    <!-- add a mat-divider to every year except the last one -->
    @if (i < ownershipForm.controls.years.controls.length - 1) {
      <mat-divider></mat-divider>
    }
  }
  </div>
  </mat-dialog-content>
</div>

<mat-dialog-actions align="end">
  <button mat-flat-button type="button" (click)="close()">OK</button>
  <button mat-flat-button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
</mat-dialog-actions>